import { defineComponent as _defineComponent } from 'vue'
import { ElectionStatus } from "@/types";
import { computed } from "vue";
import DjangoRouterLink from "@/components/links/DjangoRouterLink.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ElectionStatus',
  props: {
    race: null,
    racetrackerElectionUrl: null
  },
  setup(__props: any) {

const props = __props as {
  race: ElectionStatus;
  racetrackerElectionUrl?: string;
};



const { name, status } = props.race;
const racetrackerElectionUrl = props.racetrackerElectionUrl;

const isVP = name.includes("Vice President");

const color = computed(() => {
  return `election-status-${status.toLowerCase().replaceAll(" ", "-")}`;
});

return { __sfc: true,props, name, status, racetrackerElectionUrl, isVP, color, DjangoRouterLink }
}

})